import { SB, createSharedStateSchema } from '@play-co/replicant';
import migrator from './migrations/migrator';

export const teamCompetitionSharedStateSchema = createSharedStateSchema({
  user: {
    schema: SB.object({}),
  },
  global: {
    schema: SB.object({
      teams: SB.map(
        SB.object({
          createdAt: SB.number(),
        }),
      ),
      modifiedAt: SB.number(),
    }),
    migrator,
  },
});
